import React from 'react';
export function WomensSelfDefenseHeader() {
  return <div className="pt-36 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-2082">
      <div className="animate-fade-up-in" data-id="element-2083">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-2084">
          Women's <span className="text-[#00D4FF]" data-id="element-2085">Self-Defense</span> Seminar
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-2086">
          April 18, 2026 · 1:00 – 3:00 PM · Walker's Martial Arts, Bloomington
        </p>
      </div>
    </div>;
}